export type { CommonDealerProps } from "../types.ts";
export { DealerItemDataProvider, useSafeDealerItemContext } from "./context/DealerItemProviderContext.tsx";
export { DealerUIStateProvider, useDealerUIState } from "./context/DealerUIStateContext.tsx";
export { ModalProvider } from "./context/ModalContext.tsx";
export {
  OrganisationDataProvider,
  useOrganisationData,
} from "./context/OrganisationContext.tsx";

import { DealerRatings as Ratings } from "./components/DealerRatings.tsx";
import { withDataGuard, withDataGuardFallback } from "./context/DealerItemProviderContext.tsx";
import { withOrganisationDataGuard } from "./context/OrganisationContext.tsx";
import { ContactDealerActions as Actions, FixedActions as Fixed } from "./views/ContactDealerActions.tsx";
import { DealerInfoFallback, DealerInfoCard as InfoCard } from "./views/DealerInfoCard.tsx";
import { DealerOverviewFallback, DealerOverview as Overview } from "./views/DealerOverview.tsx";
import { DeepLinkAction as DeepLink } from "./views/DeepLinkAction.tsx";

export const DealerInfoCard = withDataGuardFallback(InfoCard, DealerInfoFallback);
export const DealerOverview = withDataGuardFallback(Overview, DealerOverviewFallback);

export const FixedActions = withDataGuard(Fixed);
export const ContactDealerActions = withDataGuard(Actions);
export const DeepLinkAction = withDataGuard(DeepLink);

export const DealerRatings = withOrganisationDataGuard(Ratings);

export { Description } from "./components/Description.tsx";
export { GoogleMapsLink, HomepageLink } from "./components/Links.tsx";
export { LocationSection } from "./components/LocationSection.tsx";
export { OpeningHours } from "./components/OpeningHours.tsx";
